import { TreeElement } from 'mbs-ui-kit';
import Computer from 'mbs-ui-shared@models/Computer';
import { PlanTypes } from 'mbs-ui-shared@models/PlanTypes.enum';
import { TypeDataStepValue } from 'wizards/models/type-data-models';

export enum ItemTypeEnum {
  Folder = 0,
  File = 1,
  Version = 2,
  Disk = 3,
  Volume = 4,
  Snapshot = 5,
  Machine = 6,
  Host = 7,
  RestorePoint = 8,
  Generation = 9,
  Bunch = 10,
  Prefix = 11,
  Connection = 12,
  DatabaseSql = 13,
  DatabaseExchange = 14,
  RestorePointIncremental = 15,
  RestorePointTLog = 16,
  Container = 17
}

export const i18KeysByType = {
  [ItemTypeEnum.Bunch]: 'backup',
  [ItemTypeEnum.Generation]: 'generation',
  [ItemTypeEnum.RestorePoint]: 'restorePoint',
  [ItemTypeEnum.RestorePointIncremental]: 'restorePoint'
};

export enum DeepSyncEnum {
  InProgress,
  InProgressColdStorage,
  InvalidPassword,
  NeedPassword,
  Done,
  Error
}

export type MyTreeElements = TreeElement & {
  computer?: Computer;
  firstRestoreDate?: string;
  lastRestoreDate?: string;
  retentionKeepBackupFor?: number;
  originalSize?: number;
  sizeOnStorage?: number;
  daysToPurge?: string;
  totalSavings?: number;
  countOfErrorStarts?: number;
  countOfSuccessfulStarts?: number;
  countOfWarningStarts?: number;
  compressionRatio?: number;
  deduplicationRatio?: number;
  duration?: string;
  date?: string;
  backupResult?: string;
  consistencyCheckResult?: string;
  restoreVerificationResult?: string;
  restorePointObjectPath?: string;
  type?: GetBackupContentType | GetBackupContentBunchType;
  itemType?: ItemTypeEnum;
  deepSync?: DeepSyncEnum;
  deepSyncProgress?: number;
  isEncrypted?: StorageEncryptionState;
  isCanBeExpand?: boolean;
  isObjectLock?: boolean;
  isLegacy?: boolean;
  IsLocal?: boolean;
  isCurrent?: boolean;
  isCanBeDeleted?: boolean;
  isDeleted?: boolean;
  isRemote?: boolean;
  isOnline?: boolean;
  isStorage?: boolean;
  isUser?: boolean;
  isAbstract?: boolean;
  sessionId?: string;
  historySessionId?: string;
  keepBackupFor?: string;
  needShowRV?: boolean;
  encryptionPasswordHint?: string;
  hideButton?: boolean;
  generationId?: string;
  prefix?: string;
  storageId?: string;
  bunchId?: string;
  restorePoint?: string;
  modifyDateUTC?: string;
  isCanBeQuickRestored?: boolean;
  iconCustom?: string;
  leftTopIcon?: string;
  rightBottomIcon?: string;
  GFSSettings?: { type: GenerationGFSType; gfsPurgeSummary?: string };
  purgeSummary?: string;
  tablePurgeSummary?: string;
  restorePath?: string;
  path?: string;

  storageAccountName?: string;
  bucket?: string;
  region?: string;
};

export enum GenerationGFSType {
  NotAssigned = 'NotAssigned',
  Weekly = 'Weekly',
  Monthly = 'Monthly',
  Yearly = 'Yearly'
}

export enum GenerationGFSTypeIcons {
  Weekly = 'assets/images/storages-tree/weekly.svg',
  Monthly = 'assets/images/storages-tree/monthly.svg',
  Yearly = 'assets/images/storages-tree/yearly.svg',
  NotAssigned = 'assets/images/storages-tree/x.svg'
}

export enum GetBackupContentBunchType {
  DiskImage = 'DiskImage',
  Exchange = 'Exchange',
  Database = 'Database',
  MsSql = 'MsSql',
  VMware = 'VMware',
  HyperV = 'HyperV',
  Proxmox = 'Proxmox',
  Files = 'Files'
}
export const GetPlanTypeFromBunchType = {
  [GetBackupContentBunchType.DiskImage]: PlanTypes.RestoreDiskImagePlan,
  [GetBackupContentBunchType.Database]: PlanTypes.RestoreDataBasePlan,
  [GetBackupContentBunchType.MsSql]: PlanTypes.RestoreDataBasePlan,
  [GetBackupContentBunchType.HyperV]: PlanTypes.RestoreHyperV,
  [GetBackupContentBunchType.VMware]: PlanTypes.RestoreVMware,
  [GetBackupContentBunchType.Proxmox]: PlanTypes.RestoreProxmox
};

export enum GetBackupContentType {
  Disk = 'Disk',
  Version = 'Version',
  Volume = 'Volume',
  File = 'File',
  Folder = 'Folder'
}

export enum TreeBunchesIcons {
  Ibb = 'assets/images/storages-tree/systemImagePlanPicture.svg',
  HyperV = 'assets/images/storages-tree/hyperv-icon.svg',
  Proxmox = 'assets/images/storages-tree/proxmox-icon.svg',
  ProxmoxContainer = 'assets/images/storages-tree/proxmox-container.svg',
  VmWare = 'assets/images/storages-tree/vmware-icon.svg',
  VmWareCurrent = 'assets/images/storages-tree/VmWareCurrent.svg',
  Exchange = 'assets/images/storages-tree/exchange.svg',
  Database = 'assets/images/storages-tree/SQL.svg'
}

export enum TreeRestorePointsIconPath {
  Server = 'assets/images/storages-tree/ServerPicture.svg',
  ServerGroup = 'assets/images/storages-tree/ServerGroupPicture.svg',
  Full = 'assets/images/storages-tree/DbFullBackupPicture.svg',
  File = 'assets/images/storages-tree/filePicture.svg',
  Disk = 'assets/images/storages-tree/DiskPicture.svg',
  ParentDisk = 'assets/images/storages-tree/CdDiskPicture.svg',
  Diff = 'assets/images/storages-tree/DbDiffBackupPicture.svg',
  Chain = 'assets/images/storages-tree/ChainDraw.svg',
  Success = 'assets/images/storages-tree/okStatusPicture.svg',
  Warn = 'assets/images/storages-tree/warningStatusPicture.svg',
  WarnTriangle = 'assets/images/storages-tree/warningTrianglePicture.svg',
  Error = 'assets/images/storages-tree/errorStatusPicture.svg',
  Encrypt = 'assets/images/storages-tree/EncryptionLockPicture.svg',
  Quest = 'assets/images/storages-tree/questionPicture.svg',
  DBPlan = 'assets/images/storages-tree/databasePlanPicture.svg'
}

export const ComputerIcon = 'assets/images/for-wizards/MyCompPicture.svg';
export const HomeComputerIcon = 'assets/images/for-wizards/HomeComputerPicture.svg';

export enum StorageEncryptionState {
  NotEncrypted,
  PossiblyEncrypted,
  Encrypted
}

export const TypesForShowWizard = [
  ItemTypeEnum.Host,
  ItemTypeEnum.RestorePoint,
  ItemTypeEnum.RestorePointIncremental,
  ItemTypeEnum.RestorePointTLog
];
export const MachineOrDisk = [ItemTypeEnum.Machine, ItemTypeEnum.Disk, ItemTypeEnum.DatabaseSql, ItemTypeEnum.DatabaseExchange];

export type RestoreClickEventTargetComputerData = {
  hid: string;
  computerName: string;
  userId: string;
  email: string;
  toComputer?: Computer;
};

export type RestoreClickEventData = {
  restoreType: RestoreTypeFromStorageTab;
  item: MyTreeElements;
  isTopLvl: boolean;
  fromSearch?: boolean;
  forDiffComp?: RestoreClickEventTargetComputerData;
  toComputer?: Computer;
  restoreTypeStep?: TypeDataStepValue;
};
export type SettingsForStepsInitial = {
  isWindows: boolean;
  join: string;
  item: MyTreeElements;
  parentIsHost: boolean;
  pointItem: MyTreeElements;
};

export enum RestoreTypeFromStorageTab {
  quick = 0,
  current = 1,
  different = 2,
  agentLess = 3
}

export enum SearchButtonsId {
  search = 'search',
  edit = 'edit'
}

export const AgentVersionForSearch = 865;
export const AgentVersionUnixAgentlessRestore = 453;
export const AgentVersionForAgentlessRestore = 870;
export const AgentVersionForRestoreVerification = 875;
export const AgentVersionForUseTokenString = '8.7.5';
